import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-labelledby"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.itemSelected != null)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "btn btn-link dropdown-toggle medium p-16",
          href: "javascript:;",
          role: "button",
          id: _ctx.id,
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, _toDisplayString(_ctx.itemSelected.text), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "dropdown-menu",
      "aria-labelledby": _ctx.id
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          class: "dropdown-item",
          href: "javascript:;",
          key: item,
          onClick: ($event: any) => (_ctx.onSelectedItem(item))
        }, _toDisplayString(item.text), 9, _hoisted_4))
      }), 128))
    ], 8, _hoisted_3)
  ]))
}